import { NamePath } from 'antd/es/form/interface'
import * as React from 'react'
import { FC } from 'react'
import { EditableContext } from '../editable-row'
import { Form, Select } from 'antd'
import { EndpointQueryParameters } from '../../../../../../types/strapi/strapi'
import { useSaveOrder } from '../../../../helpers/use-save-order'
import { useGetUsersQuery } from '../../../../../../store/api/users-api'
import Tube from '../../../../../../types/api/tube'
import { filterOptionByLabel } from '../../../../../../helpers/filter-option-by-label'

interface EditableSelectUserProps {
    namePath: NamePath
    record: Tube
    inputRef: any
    queryParams: EndpointQueryParameters

    toggleEdit: () => void
}

const EditableSelectUser: FC<EditableSelectUserProps> = ({
    namePath,
    record,
    inputRef,
    queryParams,
    toggleEdit,
}) => {
    const form = React.useContext(EditableContext)
    const { data } = useGetUsersQuery()
    const saveOrder = useSaveOrder()
    const userData = data?.map(item => ({ value: item.documentId, label: item.username }))
    const initialInitiator = record.stamps?.[0]?.last_order?.initiator
    const initialValue = { label: initialInitiator?.username, value: initialInitiator?.documentId }

    const save = async () => {
        try {
            toggleEdit()
            if (!form) return
            const value: Partial<Tube> = form.getFieldsValue()

            if (record.stamps?.[0]?.last_order) {
                const initiator = value?.stamps?.[0]?.last_order?.initiator
                if (initiator && initiator?.documentId !== initialInitiator?.documentId) {
                    await saveOrder('initiator', initiator, record, queryParams)
                }
            }
        } catch (errInfo) {
            console.log('Save failed:', errInfo)
        }
    }

    return (
        <Form.Item
            initialValue={initialValue}
            style={{
                margin: 0,
            }}
            name={namePath}
        >
            <Select
                ref={inputRef}
                onChange={save}
                onBlur={save}
                options={userData}
                showSearch
                filterOption={filterOptionByLabel}
            />
        </Form.Item>
    )
}

export default EditableSelectUser
